var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnauthorized(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_384_3725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 16.0003C12.4183 16.0003 16.0001 12.4185 16.0001 8.00016C16.0001 3.58179 12.4183 0 7.99992 0C3.58155 0 -0.000244141 3.58179 -0.000244141 8.00016C-0.000244141 12.4185 3.58155 16.0003 7.99992 16.0003Z",
    fill: "#FE9A79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 8.00016L10.6666 10.6668M10.6666 5.3335L7.99992 8.00016L10.6666 5.3335ZM7.99992 8.00016L5.33325 10.6668L7.99992 8.00016ZM7.99992 8.00016L5.33325 5.3335L7.99992 8.00016Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_384_3725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorized);
export default __webpack_public_path__ + "static/media/unauthorized.4c8af382aa0258f8e4d360ef063c41e3.svg";
export { ForwardRef as ReactComponent };